// The single source of truth for the v2 planner. A plain observable object:
// Stimulus controllers and the Konva renderer all read from it and subscribe to
// changes. No p5 ServiceProvider / getter web.

export default class Store {
  constructor() {
    this.state = {
      loaded: false,
      name: null,
      view: { scale: 1, posX: 0, posY: 0 },
      settings: {},
      layers: [],
      elements: [],
      species: {},      // id -> meili object (server-resolved, read cache)
      selection: [],    // element ids
      activeTool: 'select',
      activeTab: 'search',
      pendingSpecies: null,
      timelineOn: false,
      timelineMonth: null, // year*12 + (month-1)
      snapStep: 0, // plan units; 0 = off
      dirty: false,
    };
    this.listeners = new Set();
  }

  get(key) { return this.state[key]; }

  // Shallow-merge a patch and notify. `meta.source` lets subscribers ignore
  // their own echoes (e.g. the renderer ignoring a view change it caused).
  set(patch, meta = {}) {
    Object.assign(this.state, patch);
    this.emit(meta);
  }

  subscribe(fn) {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  emit(meta = {}) {
    for (const fn of this.listeners) fn(this.state, meta);
  }

  // Load a migrated v4 plan payload into the store.
  loadPlan(plan) {
    const view = plan.view && Object.keys(plan.view).length
      ? { scale: plan.view.scale ?? 1, posX: plan.view.posX ?? 0, posY: plan.view.posY ?? 0 }
      : { scale: 1, posX: 0, posY: 0 };
    this.set({
      loaded: true,
      name: plan.name ?? null,
      view,
      settings: plan.settings ?? {},
      layers: plan.layers ?? [],
      elements: (plan.elements ?? []).map((el, i) => ({ id: el.id ?? `el-${i}`, ...el })),
      species: plan.species ?? {},
    }, { source: 'load' });
  }

  layerById(id) {
    return this.state.layers.find((l) => l.id === id) || null;
  }
}
